import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "",
  data: function data() {
    return {
      LogPriorityList: [{
        value: '8',
        label: this.$t('lang.smartlink.debug')
      }, {
        value: '7',
        label: this.$t('lang.smartlink.info')
      }, {
        value: '6',
        label: this.$t('lang.smartlink.notice')
      }, {
        value: '5',
        label: this.$t('lang.smartlink.alarm')
      }, {
        value: '4',
        label: this.$t('lang.smartlink.error')
      }, {
        value: '3',
        label: this.$t('lang.smartlink.deadly')
      }, {
        value: '2',
        label: this.$t('lang.smartlink.alert')
      }, {
        value: '1',
        label: this.$t('lang.smartlink.emergency')
      }],
      options: {}
    };
  },
  methods: {
    saveAdvanced: function saveAdvanced() {
      this.$emit('saveAdvanced', _objectSpread(_objectSpread({}, this.options), {}, {
        enabled: this.options.enabled ? 1 : 0,
        enable_debug: this.options.enable_debug ? 1 : 0
      }));
    },
    downloadLog: function downloadLog() {
      this.$emit('downloadLog');
    },
    refesh: function refesh() {
      this.$emit('refesh');
    }
  }
};